<script setup lang="ts">
import { HvcIcon } from '@laam/ui/icons';
</script>

<template>
	<div
		class="rounded border inline-flex flex-nowrap lg:h-7xl items-center font-semibold py-xxs lg:py-xs px-xs lg:px-sm gap-xxs bg-orange-50 border-orange-200 [&_svg]:fill-orange-600"
	>
		<HvcIcon weight="fill" />
		<p
			class="text-xs tracking-[-0.24px] font-semibold text-orange-600 !text-nowrap"
		>
			Loyalty Discount
		</p>
	</div>
</template>
